import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import InputBase from '~components/input/input';
import { ArrowV, BasicCalendar } from '~static/svg-components';
import hexToRGBA from '~utils/hex-to-rgba';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 99,
    backgroundColor: hexToRGBA(theme.colors.greyE8, 0.6),
    border: 'none',

    '&$focused:not($error)': { '& $iconCalendar': { fill: theme.colors.grey66 } },
    '&$disabled': {
      border: 'none',
      backgroundColor: theme.colors.greyF7,
      color: theme.colors.grey99,
      '& $iconCalendar': { fill: theme.colors.grey99 },
    },
    '&:not($error):not($disabled):hover': {
      backgroundColor: hexToRGBA(theme.colors.greyE8, 0.6),
    },
  },
  focused: {
    border: 'none',
    backgroundColor: hexToRGBA(theme.colors.greyE8, 0.6),
    boxShadow: 'none',
  },
  error: {},
  disabled: {},
  input: {
    '&$inputAdornedStart': {
      paddingLeft: 36,
    },

    '&$inputAdornedEnd': {
      paddingRight: 36,
    },
  },
  inputAdornedStart: {},
  inputAdornedEnd: {},

  iconCalendar: {
    position: 'absolute',
    fill: theme.colors.grey66,
    pointerEvents: 'none',
  },

  iconCalendarStart: {
    left: 12,
  },

  iconCalendarEnd: {
    right: 16,
    fontSize: 10,
    transform: 'rotate(90deg)',
    transition: 'transform 150ms cubic-bezier(0.65, 0.05, 0.36, 1)',
  },

  iconCalendarEndActive: {
    transform: 'rotate(270deg)',
  },
}));

const RoundInput = React.forwardRef(
  ({ iconPlacement, tippyInstance, isOpenDatePicker, ...otherProps }, ref) => {
    const classes = useStyles();
    return (
      <InputBase
        ref={ref}
        classes={{
          root: classes.root,
          focused: classes.focused,
          error: classes.error,
          input: classes.input,
          disabled: classes.disabled,
          inputAdornedStart: classes.inputAdornedStart,
          inputAdornedEnd: classes.inputAdornedEnd,
        }}
        fullWidth
        startAdornment={
          iconPlacement === 'start' && (
            <BasicCalendar
              className={classNames(classes.iconCalendar, classes.iconCalendarStart)}
            />
          )
        }
        endAdornment={
          iconPlacement === 'end' && (
            <ArrowV
              className={classNames(classes.iconCalendar, classes.iconCalendarEnd, {
                [classes.iconCalendarEndActive]: isOpenDatePicker,
              })}
            />
          )
        }
        {...otherProps}
      />
    );
  }
);

RoundInput.propTypes = {
  iconPlacement: PropTypes.oneOf(['start', 'end']),
  tippyInstance: PropTypes.object,
  isOpenDatePicker: PropTypes.bool,
};

RoundInput.defaultProps = {
  iconPlacement: 'end',
  tippyInstance: undefined,
};

export default RoundInput;
